import { EthernetProductsState } from "./types";

const initialState: EthernetProductsState = {
  configurations: [],
  configurationIndexesSubmitted: [],
};

export default initialState;
